import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CompetitionLeaderboard from "../../components/CompetitionLeaderboard";
import { Container } from "../../components/CompetitionLeaderboard/CompetitionLeaderboard.style";
import useCompetitionMaster from "../../components/CompetitionScoreboard/hooks/useCompetitionMaster";
import Navbar from "../../components/Navbar";
import { Button } from "./CompetitionLeaderboard.style";
import useCompetitionHandicapCategories from "../../components/CompetitionScoreboard/hooks/useCompetitionCategories";
import { HandicapCategory } from "../../Types/HandicapCategory";

export enum GameFormats {
  Strokeplay = 0,
  Stableford = 1,
  Matchplay = 2,
  Skins = 3,
  DoublePeoria = 4,
}

const gameFormats: { [key in GameFormats]: string } = {
  [GameFormats.Strokeplay]: "StrokePlay",
  [GameFormats.Stableford]: "Stableford",
  [GameFormats.Matchplay]: "Matchplay",
  [GameFormats.Skins]: "Skins",
  [GameFormats.DoublePeoria]: "Double Peoria",
};

function getGameFormatName(format: GameFormats): string {
  return gameFormats[format];
}

function CompetitionLeaderboardPage() {
  const { competitionId = "" } = useParams();
  const {
    competitionMaster,
    isLoading: isMasterLoading,
    error: masterError,
  } = useCompetitionMaster(competitionId);

  const {
    handicapCategories,
    isLoading: isHandicapCategoriesLoading,
    error: handicapCategoriesError,
  } = useCompetitionHandicapCategories(competitionId);

  const [categoryType, setCategoryType] = useState<string | null>(null);

  const [leaderboardFormat, setLeaderboardFormat] = useState(0);

  const [isGross, setIsGross] = useState<boolean | null>(true);

  console.log("value of is Gross", isGross);
  return (
    <React.Fragment>
      <Navbar competitionMaster={competitionMaster} />
      <Container
        style={{ display: "flex", flexDirection: "column", rowGap: 0, flex: 0 }}
      >
        <div
          style={{
            display: "flex",
            gap: "0.5em",
            padding: "1em",
            background: "none",
          }}
        >
          <Button
            selected={Boolean(isGross)}
            onClick={(e) => {
              e.preventDefault();
              setIsGross(true);
              setCategoryType(null);
              setLeaderboardFormat(0);
            }}
          >
            Gross
          </Button>

          {(competitionMaster?.scoringMethod !== GameFormats.DoublePeoria ||
            (competitionMaster?.secretHolesRevealed &&
              competitionMaster?.scoringStatus === 2)) && (
            <Button
              onClick={(e) => {
                e.preventDefault();
                setIsGross(false);
                if (competitionMaster?.scoringMethod === 0) {
                  setLeaderboardFormat(1);
                }
                if (competitionMaster?.scoringMethod === 1) {
                  setLeaderboardFormat(2);
                }
                if (competitionMaster?.scoringMethod === 2) {
                  setLeaderboardFormat(3);
                }
                if (competitionMaster?.scoringMethod === 3) {
                  setLeaderboardFormat(4);
                }
                if (competitionMaster?.scoringMethod === 4) {
                  setLeaderboardFormat(5);
                }
              }}
              selected={!isGross}
            >
              {getGameFormatName(competitionMaster?.scoringMethod ?? 0) ?? ""}
            </Button>
          )}
        </div>
        {!isGross && (
          <div style={{ display: "flex", gap: "0.5em", padding: "0em 1em" }}>
            <Button
              selected={categoryType == null}
              onClick={(e) => {
                e.preventDefault();
                setCategoryType(null);
              }}
            >
              All
            </Button>

            {competitionMaster?.handicapCategories != null &&
              competitionMaster?.handicapCategories?.map((obj: any) => (
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    setCategoryType(obj.type?.toString());
                  }}
                  selected={obj.type == categoryType}
                  key={obj.type}
                >
                  {obj.typeName}
                </Button>
              ))}

            {competitionMaster?.handicapCategories == null &&
              handicapCategories?.map((obj: HandicapCategory) => (
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    setCategoryType(obj.objectId);
                  }}
                  selected={obj.objectId === categoryType}
                  key={obj.type}
                >
                  {obj.typeName}
                </Button>
              ))}
          </div>
        )}
      </Container>

      <CompetitionLeaderboard
        competitionId={competitionMaster?.objectId}
        handicapCategoryType={categoryType}
        isGross={isGross}
        competitionMaster={competitionMaster}
        leaderboardFormat={leaderboardFormat}
        isLeagueLeaderboard={false}
      />
    </React.Fragment>
  );
}

export default CompetitionLeaderboardPage;
